export const PickedStatus = {
	PUBLISHED: 'PUBLISHED',
	QUOTED: 'QUOTED',
	CARRIER_ASSIGNED: 'CARRIER_ASSIGNED',
	COMPLETED: 'COMPLETED',
	CONCEPT: 'CONCEPT',
} as const;

export type PickedStatus = (typeof PickedStatus)[keyof typeof PickedStatus];
